// extracted by mini-css-extract-plugin
export default {"text":"duration-view_text__tOdU8","noText":"duration-view_noText__MmVVH","editable":"duration-view_editable__Sz6KB"};